import { PROFANITY_CHECK } from "constants/errorCodes";

const getRegistrationErrorMessage = (code) => {
  const codes = {
    [PROFANITY_CHECK]:
      "Unfortunately there was an error as your name does not meet our criteria. Please try again.",
    default:
      "There was an error and we were unable to submit your request. Please try again.",
  };
  return codes[code] || codes.default;
};

export default getRegistrationErrorMessage;
